<template>
    <div>
        <b-container class="mt-3">
            <b-list-group>
                <b-list-group-item
                    v-for="(user, key) in userList"
                    :key="key"
                    tag="a"
                    :button="false"
                    :to="{
                        name: 'admin.users.Profile',
                        params: {userId: user.user_id},
                    }"
                    @click.native="emitSelectedUser(user)"
                >
                    {{ user.fname }} {{ user.lname }} ({{ user.email }})
                </b-list-group-item>
            </b-list-group>
        </b-container>
    </div>
</template>

<script>
export default {
    props: {
        criteria: {
            type: String,
            default: ''
        },
    },

    data() {
        return {
            userList: [],
            lastSearchCriteria: null,
        };
    },

    computed: {
        searchCriteria() {
            return this.criteria;
        },
    },

    watch: {
        criteria() {
            this.submitSearch();
        },
    },

    created() {
        this.submitSearch();
    },

    methods: {
        emitSelectedUser(user) {
            this.$emit('userSelected', user);
        },

        async submitSearch() {
            this.lastSearchCriteria = this.criteria;
            this.userList = await this.$store.dispatch('auth/searchUsers', {
                criteria: this.searchCriteria,
            });
            this.$emit('searchCompleted', this.userList);
        },
    },
};
</script>
